import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const FlagIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.4123 5.7L15.8124 2.47C15.917 2.32879 15.9807 2.161 15.9963 1.98538C16.0118 1.80976 15.9787 1.63322 15.9006 1.47551C15.8224 1.3178 15.7024 1.18513 15.5539 1.09233C15.4053 0.999526 15.2341 0.950246 15.0594 0.95H3.76486C3.76486 0.698044 3.6657 0.456408 3.48918 0.278249C3.31267 0.100089 3.07327 0 2.82365 0C2.57402 0 2.33462 0.100089 2.15811 0.278249C1.98159 0.456408 1.88243 0.698044 1.88243 0.95V17.1H0.941215C0.691589 17.1 0.452188 17.2001 0.275676 17.3782C0.0991636 17.5564 0 17.798 0 18.05C0 18.302 0.0991636 18.5436 0.275676 18.7218C0.452188 18.8999 0.691589 19 0.941215 19H4.70608C4.9557 19 5.1951 18.8999 5.37161 18.7218C5.54813 18.5436 5.64729 18.302 5.64729 18.05C5.64729 17.798 5.54813 17.5564 5.37161 17.3782C5.1951 17.2001 4.9557 17.1 4.70608 17.1H3.76486V10.45H15.0594C15.2341 10.4498 15.4053 10.4005 15.5539 10.3077C15.7024 10.2149 15.8224 10.0822 15.9006 9.92449C15.9787 9.76678 16.0118 9.59025 15.9963 9.41462C15.9807 9.239 15.917 9.07121 15.8124 8.93L13.4123 5.7Z"
        fill="currentColor"
      />
    </svg>
  )
})

FlagIcon.displayName = 'FlagIcon'
